<template>
	<ui-button type="button" design="md link" :class="design" @click="closeHandle">
		<slot></slot>
	</ui-button>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'

	export default {
		components: {
			uiButton,
		},
		name: 'ui-modal-cancel-button',
		props: {
			/**
			 * Essa propriedade espera o nome do modal a ser fechado.
			 */
			modalName: {
				type: String,
				default: '',
			},
			/**
			 * Utilize para aplicar classes ao botão de cancelar
			 */
			design: {
				type: String,
				default: '',
			},
			/**
			 * Utilize para passar o evento a ser emitido para o Google
			 */
			trackEvent: {
				type: Object,
				default: null,
			},
		},
		methods: {
			/**
			 * closeHandle() fechará o modal passado por props
			 */
			closeHandle() {
				/**
				 * Emite o evento do Google Analytics
				 */
				if (this.trackEvent) {
					this.$gtm.trackEvent(this.trackEvent)
				}

				if (this.modalName) {
					this.$root.$emit('modal-close-' + this.modalName)
					this.$emit('close')
				}
			},
		},
	}
</script>
